import { Component } from "@angular/core";

@Component({
  selector: "app-survey-frame-list",
  templateUrl: "./survey-frame-list.component.html",
  styleUrls: ["./survey-frame-list.component.scss"],
})
export class SurveyFrameListComponent {
  constructor() {}
}
